

const Footer = () => {
    return (
        <div>
            <h5>Copyright 2021*</h5>
        </div>
    )
}

export default Footer

